
import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "transparent", // Transparent to show parent gradient
        py: 6,
        borderTop: 'none', // No border as per seamless design
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>

          {/* Logo Section */}
          {/* Logo Section */}
          <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
            <img
              src="https://github.com/appversal/filehost/blob/main/download.png?raw=true"
              style={{ width: "160px", height: "auto", cursor: "pointer" }}
              alt="logo of App20"
              onClick={() => window.location.href = "/"}
            />
          </Box>

          {/* Bottom Row */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'space-between',
              alignItems: { xs: 'flex-start', md: 'flex-end' },
              gap: 3,
              mt: 2
            }}
          >
            {/* Links and Copyright */}
            <Box>
              <Stack direction="row" spacing={1} sx={{ mb: 1, alignItems: 'center' }}>
                <Link href="#" underline="none" sx={{ color: '#000', fontSize: '14px', fontWeight: 500 }}>
                  Privacy Policy
                </Link>
                <Typography sx={{ color: '#000', fontSize: '14px' }}>•</Typography>
                <Link href="#" underline="none" sx={{ color: '#000', fontSize: '14px', fontWeight: 500 }}>
                  Cookie Policy
                </Link>
              </Stack>
              <Typography sx={{ color: '#000', fontSize: '14px', opacity: 0.8 }}>
                Copyright © App20 {new Date().getFullYear()}
              </Typography>
            </Box>

            {/* Social Icons */}
            <Stack direction="row" spacing={2}>
              <IconButton
                sx={{
                  color: '#000',
                  border: '1px solid #000',
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.1)' }
                }}
                href="#"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                sx={{
                  color: '#000',
                  border: '1px solid #000',
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.1)' }
                }}
                href="#"
                aria-label="X"
              >
                <XIcon />
              </IconButton>
              <IconButton
                sx={{
                  color: '#000',
                  border: '1px solid #000',
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.1)' }
                }}
                href="#"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </IconButton>
            </Stack>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
